import React, { useState, useEffect, use } from "react";
import { useDispatch } from "react-redux";
import { insuranceActions } from "../../../core/actions";
import TextField from "@mui/material/TextField";
import { Grid, List } from "@mui/material";
import Button from "@mui/material/Button";
import { Alert } from "@mui/material";
import { useOrganization } from "../../../configurations/OrganizationContext";
import useDynamicFontFormatter from "../../../shared/helper/useDynamicFontFormatter";

function InsuranceMasteradd(props) {
  const dispatch = useDispatch();
  const organization = useOrganization();
  const formatText = useDynamicFontFormatter(organization?.fontStyle);
  const [formErrors, setFormErrors] = useState({
    email: "",
    phone1: "",
    companyName: "",
  });

  const [addFlag, setTextFlag] = useState(false);
  const [insuranceDetail, setInsuranceDetail] = useState({
    id: "",
    companyName: "",
    address: "",
    email: "",
    phone1: "",
    phone2: "",
    description: "",
  });
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });

  const isEmail = (email) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
  const noFormatFields = ["email"];

  const handleInputChange = (name, value) => {
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
    setInsuranceDetail((prev) => ({
      ...prev,
      [name]: noFormatFields.includes(name) ? value : formatText(value),
    }));
  };

  const validateField = (fieldName, value) => {
    switch (fieldName) {
      case "phone1":
        if (!value) return "Please Enter Phone Number";
        if (!/^\d{10}$/.test(value))
          return "Please Enter a Valid 10-digit Phone Number";
        return "";

      case "companyName":
        if (!value || value.trim() === "") return "Please Enter Company Name";
        return "";

      case "email":
        if (!value) return "Please Enter Email";
        if (!isEmail(value)) return "Please Enter Valid Email";
        return "";

      default:
        return "";
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const errors = {
      companyName: validateField("companyName", insuranceDetail.companyName),
      email: validateField("email", insuranceDetail.email),
      phone1: validateField("phone1", insuranceDetail.phone1),
    };
    setFormErrors(errors);

    const isValid = !errors.companyName && !errors.email && !errors.phone1;
    if (!isValid) return;

    const payload = { ...insuranceDetail };
    const action = props.location?.state?.rowData
      ? insuranceActions.modifyInsurance
      : insuranceActions.addInsuranceMaster;

    dispatch(
      action(payload, (resCb) => {
        if (resCb) {
          const message = props.location?.state?.rowData
            ? "Insurance updated successfully"
            : "Insurance added successfully";
          setServerRes({ success: message });
          setTimeout(() => {
            props.history.push("/insuremasterlist");
          }, 2000);
        } else {
          setServerRes({
            error: "Failed to save insurance. Please try again.",
          });
        }
      })
    );
  };

  useEffect(() => {
    if (props.location?.state?.rowData) {
      const data = props.location.state.rowData;
      setInsuranceDetail(data);
      setTextFlag(true);
    }
  }, []);

  const toggle = () => props.history.push("/insuremasterlist");

  return (
    <>
      {ServerRes.success && (
        <Alert severity="success">{ServerRes.success}</Alert>
      )}
      {ServerRes.error && <Alert severity="error">{ServerRes.error}</Alert>}

      <div className="mainsection">
        <h5>{addFlag ? "Edit" : "Add"} Insurance</h5>
        <main className="mainsection" id="mainsectioninsurence1">
          <List>
            <div className="p-2 bg-none">
              <form>
                {/* Row 1: Company Name, Email */}
                <Grid container spacing={2} className="local-grid-override">
                  <Grid item md={6}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Company Name"
                      value={insuranceDetail.companyName}
                      onChange={(e) =>
                        handleInputChange("companyName", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.companyName}
                        </span>
                      }
                      error={!!formErrors.companyName}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={6}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Email Id"
                      value={insuranceDetail.email}
                      onChange={(e) =>
                        handleInputChange("email", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.email}
                        </span>
                      }
                      error={!!formErrors.email}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                {/* Row 2: Phone Numbers */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={6}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Phone Number 1"
                      type="tel"
                      value={insuranceDetail.phone1}
                      onChange={(e) =>
                        handleInputChange("phone1", e.target.value)
                      }
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.phone1}
                        </span>
                      }
                      error={!!formErrors.phone1}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={6}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Phone Number 2"
                      type="tel"
                      value={insuranceDetail.phone2}
                      onChange={(e) =>
                        handleInputChange("phone2", e.target.value)
                      }
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                {/* Row 3: Description */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={6}>
                    <TextField
                      className="py-2"
                      fullWidth
                      label="Description"
                      multiline
                      value={insuranceDetail.description}
                      onChange={(e) =>
                        handleInputChange("description", e.target.value)
                      }
                      variant="outlined"
                    />
                  </Grid>
                </Grid>

                {/* Buttons */}
                <div
                  className="buttonsetconfirm"
                  style={{
                    marginTop: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "12px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={toggle}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    style={{ textTransform: "none" }}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>
          </List>
        </main>
      </div>
    </>
  );
}

export default InsuranceMasteradd;
